// extracted by mini-css-extract-plugin
module.exports = {"picture":"UploaderStyles_picture__YKwJs","icon":"UploaderStyles_icon__1liAg","loading":"UploaderStyles_loading__2IgCi","directions":"UploaderStyles_directions__TBbfn"};